import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '请求参数',
    type: 'FC_REQ',
}
